import React, { useContext } from "react";
import { Box } from "@mui/material";
import MDTypography from "components/MDTypography";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { AuthContext } from "context";
import Link from "@mui/material/Link";
import SidenavCollapse from "./SidenavCollapse";
import { NavLink } from "react-router-dom";
import Divider from "@mui/material/Divider";

function SubMenuSecurity(props) {
	const authContext = useContext(AuthContext);
	const [isHovered, setIsHovered] = React.useState(false);
	const [submenuOpen, setSubmenuOpen] = React.useState(false);
	const [fornitoriOpen, setFornitoriOpen] = React.useState(false);
	const [bottoliOpen, setBottoliOpen] = React.useState(false);

	const hasAnyAuth = (routeAuths) => {
		if (!routeAuths || routeAuths.length === 0) return true;
		return routeAuths.some((auth) => authContext.hasAuth(auth));
	};

	const filteredFornitoriRoutes = props?.routes.filter((route) => {
		if (route.type === "Sicurezza" && route.submenu === "Fornitori") return hasAnyAuth(route.auths);
	});

	const filteredBottoliRoutes = props?.routes.filter((route) => {
		if (route.type === "Sicurezza" && route.submenu === "Bottoli") return hasAnyAuth(route.auths);
	});

	const filteredGeneralSecurityRoutes = props?.routes.filter((route) => {
		if (route.type === "Sicurezza" && !route.submenu) return hasAnyAuth(route.auths);
	});

	const renderRoutesType = (routes) => {
		return routes.map(({ type, name, icon, title, noCollapse, key, href, route, showInSidebar }) => {
			let returnValue;

			if (showInSidebar) {
				returnValue = href ? (
					<Link href={href} key={key} target="_blank" rel="noreferrer" sx={{ textDecoration: "none" }}>
						<SidenavCollapse
							name={name}
							icon={icon}
							active={key === props?.collapseName.split("/")[0]}
							noCollapse={noCollapse}
						/>
					</Link>
				) : (
					<NavLink key={key} to={route}>
						<SidenavCollapse name={name} icon={icon} active={key === props?.collapseName.split("/")[0]} />
					</NavLink>
				);
			}
			return returnValue;
		});
	};

	function handleMouseEnter() {
		setIsHovered(true);
	}

	function handleMouseLeave() {
		setIsHovered(false);
	}

	function handleSubmenuOpen() {
		setSubmenuOpen((prevState) => !prevState);
	}

	function handleFornitoriOpen() {
		setFornitoriOpen((prevState) => !prevState);
	}

	function handleBottoliOpen() {
		setBottoliOpen((prevState) => !prevState);
	}

	if (filteredFornitoriRoutes.length === 0 && filteredBottoliRoutes.length === 0 && filteredGeneralSecurityRoutes.length === 0) {
		return null;
	}

	return (
		<>
			<Box>
				<Box
					display="flex"
					alignItems="center"
					justifyContent="center"
					style={{
						cursor: "pointer",
						transition: "all 0.3s ease-in-out",
					}}
					onMouseEnter={() => handleMouseEnter()}
					onMouseLeave={() => handleMouseLeave()}
					onClick={() => handleSubmenuOpen()}
				>
					<MDTypography
						color={"white"}
						variant="body2"
						fontWeight="medium"
						style={{
							fontSize: isHovered ? "1.1rem" : "1rem",
							transition: "all 0.2s ease-in",
						}}
					>
						Sicurezza
					</MDTypography>
					<KeyboardArrowDownIcon color={"white"} style={{ marginLeft: "5px" }} fontSize={"medium"} />
				</Box>

				{submenuOpen && (
					<Box sx={{}}>
						{filteredGeneralSecurityRoutes.length > 0 && <Box sx={{}}>{renderRoutesType(filteredGeneralSecurityRoutes)}</Box>}

						{filteredFornitoriRoutes.length > 0 && (
							<Box>
								<Box
									style={{
										cursor: "pointer",
										padding: "8px 0",
										paddingRight: "24px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
									onClick={() => handleFornitoriOpen()}
								>
									<MDTypography color={"white"} variant="body2" fontWeight="regular" style={{ fontSize: "1rem" }}>
										Fornitori
									</MDTypography>
									<KeyboardArrowDownIcon
										fontSize="small"
										style={{
											color: "white",
										}}
									/>
								</Box>
								{fornitoriOpen && <Box sx={{ paddingLeft: "20px" }}>{renderRoutesType(filteredFornitoriRoutes)}</Box>}
							</Box>
						)}

						{filteredBottoliRoutes.length > 0 && (
							<Box>
								<Box
									display="flex"
									alignItems="center"
									style={{
										cursor: "pointer",
										padding: "8px 0",
										paddingRight: "24px",
										display: "flex",
										alignItems: "center",
										justifyContent: "center",
									}}
									onClick={() => handleBottoliOpen()}
								>
									<MDTypography color={"white"} variant="body2" fontWeight="regular" style={{ fontSize: "1rem" }}>
										Bottoli
									</MDTypography>
									<KeyboardArrowDownIcon
										fontSize="small"
										style={{
											color: "white",
										}}
									/>
								</Box>
								{bottoliOpen && <Box sx={{ paddingLeft: "20px" }}>{renderRoutesType(filteredBottoliRoutes)}</Box>}
							</Box>
						)}
					</Box>
				)}
			</Box>
			<Divider light={true}></Divider>
		</>
	);
}

export default SubMenuSecurity;
